export function Footer() {
    return (
        <footer className="text-neutral pb-6 pt-16 w-full px-4 md:px-0 max-w-7xl mx-auto flex justify-center items-center flex-wrap gap-4 border-neutral">
            <p className="text-xs">
                © {new Date().getFullYear()} Manuel Romero. All rights reserved.
            </p>
        </footer>
    );
}

export default Footer;
